import { puCurrency } from '~/lang/formatters/puCurrency'
import { MoneyType } from './money'

export function formatPrice(
  price: MoneyType,
  locale: string,
  options = { roundToMajorUnit: false },
) {
  const priceDisplay = options.roundToMajorUnit
    ? zeroFractionDigitsPrice(price)
    : handleZeroDecimalCurrencies(price)

  return puCurrency(
    priceDisplay.price,
    locale,
    `currency:${priceDisplay.currency} minimumFractionDigits:${priceDisplay.minimumFractionDigits}`,
  )
}

function handleZeroDecimalCurrencies(price: MoneyType): PriceObjectDisplay {
  return ZERO_DECIMAL_CURRENCIES.includes(price.getCurrency())
    ? zeroFractionDigitsPrice(price)
    : {
      // ...price,
      price: price.getAmount() / 100,
      minimumFractionDigits: getMinFractionDigits(price),
      currency: price.getCurrency(),
    }
}

function zeroFractionDigitsPrice(price: MoneyType): PriceObjectDisplay {
  return {
    // ...price,
    currency: price.getCurrency(),
    price: Math.round(price.getAmount() / 100),
    minimumFractionDigits: 0,
  }
}

function getMinFractionDigits(money: MoneyType) {
  return money.hasSubUnits() ? 2 : 0
}

const ZERO_DECIMAL_CURRENCIES = [
  'BIF',
  'CLP',
  'DJF',
  'GNF',
  'JPY',
  'KMF',
  'KRW',
  'MGA',
  'PYG',
  'RWF',
  'VND',
  'VUV',
  'XAF',
  'XOF',
  'XPF',
]

interface PriceObjectDisplay {
  price: number
  currency: string
  minimumFractionDigits: number
}
